import LinkButton from '~/components/button/LinkButton';
import Submit from '~/components/button/Submit';
import Form from '~/components/Form';
import Divider from '~/components/layout/divider/Divider';
import Page from '~/components/layout/page/Page';
import ProductExchange from './product-exchange/ProductExchange';
import { FormKey, useLoaderData } from './resolution';

function Credit({ className }: { className?: string }) {
  const {
    canExchange,
    creditResolutionMethod,
    creditDetailText,
    creditTitle,
    aiExchangeRecommendation,
  } = useLoaderData();

  return (
    <Page.Section
      title={canExchange ? creditTitle : 'Next Steps'}
      className={className}
    >
      <p>{creditDetailText}</p>
      <Form
        id="credit"
        name="credit"
        className="flex flex-col gap-4"
        aria-label="credit"
      >
        <input
          type="hidden"
          hidden
          data-testid="creditResolution"
          name={FormKey.resolution}
          value={creditResolutionMethod}
        />
        {aiExchangeRecommendation && (
          <input
            type="hidden"
            hidden
            name={FormKey.exchangeRecommendation}
            defaultValue={JSON.stringify(aiExchangeRecommendation)}
          />
        )}
        <Submit form="credit" variant="outlined">
          Continue with return
        </Submit>
      </Form>
    </Page.Section>
  );
}

function EscapeHatch() {
  const { canExchange, orderId, store } = useLoaderData();

  // ? in the case that a customer doesn't want a variant exchange, we show the escape hatch indicating to reach out to the merchant
  // ? isExchangeOnly should allow variant exchange OR store credit
  const message = canExchange
    ? "If an exchange doesn't fit your needs, please reach out to our team."
    : "It looks like we can't handle this return automatically, please reach out to our team.";

  return (
    <Page.Section title="Need help?">
      <p>{message}</p>
      <LinkButton
        className="mt-6 w-full md:w-1/2"
        variant="outlined"
        to={`/${store}/order/${orderId}`}
      >
        Back to Order
      </LinkButton>
    </Page.Section>
  );
}

export default function ResolutionPage() {
  // shouldPrioritizeCredit is a boolean that determines if the refund should be prioritized over the exchange (what order the cards display)
  const { canExchange, canCredit, shouldPrioritizeCredit } = useLoaderData();

  const content = [
    canExchange && <ProductExchange key="exchange" />,
    // TODO hide credit within a product variant selection if there are exchange products
    canCredit ? <Credit key="credit" /> : <EscapeHatch key="escape" />,
  ].filter(Boolean);

  if (canCredit && shouldPrioritizeCredit) content.reverse();

  if (content.length > 1) content.splice(1, 0, <Divider key="divider" />);

  return content;
}
